<template>
    <v-tooltip
        bottom
        open-delay="250"
        max-width="300"
        :disabled="!title || title.length < 45"
    >
        <template v-slot:activator="{ on: tooltipOn }">
            <div class="text-truncate px-1 caption" :class="pointer ? 'cursor-pointer' : ''" style="max-width: 250px;" v-on="tooltipOn" @click="$emit('click', $event)">
                <span>{{ title }}</span>
            </div>
        </template>
        <span style="overflow-wrap: break-word;">{{ title }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "RichDataTableOverflowTooltipText",
    props: {
        title: {
            type: String,
            default: ""
        },
        pointer: {
            type: Boolean,
            default: false
        }
    }
};
</script>
